/*************************************************/
/* DOWNLOADS                                     */
/*************************************************/

export function downloads() {
    function handleShowMore(container) {
        container.addEventListener("click", function (event) {
            if (event.target && event.target.classList.contains("btn-show-more")) {
                var hiddenItems = container.querySelectorAll(".download-item__download-item.hidden");
                hiddenItems.forEach(function (item) {
                    item.classList.remove("hidden");
                });
                var showMoreButton = event.target;
                if (showMoreButton) {
                    showMoreButton.style.display = "none";
                }
            }
        });
    }

    document.addEventListener("DOMContentLoaded", function () {
        const downloadContainers = document.querySelectorAll(".download-item");

        downloadContainers.forEach(function (container) {
            handleShowMore(container);
        });
    });
}